export default __webpack_public_path__ + "bc372e984f6b8032afc191b821a6f4ab.webp";